/* eslint-disable react/prop-types */
import  { useEffect, useState } from "react";
import { NavigateNext, NavigateBefore } from "@mui/icons-material";
import "./PhotoGallery.css";
import SuperZoomMagnifier from "../../ui/ZoomImageMagnifier";

const PhotoGallery = ({ bgimage, setBgimage, images, isLoading, setIsLoading }) => {
  const [index, setIndex] = useState(0);
  const [showZoom, setShowZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (images?.length) {
      setIndex(0); // Reinicia el índice al cambiar las imágenes
      // console.log("HOLA")
      setIsLoading(false);
    }
  }, [images]);

  useEffect(() => {
    if (images?.length > 0) {
      setBgimage(images[index]?.pathname); // Asegura la primera imagen del nuevo producto
    }
  }, [index]);
  

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setZoomPosition({ x: x, y: y });
  };


  const checkNumber = (number) => {
    if (number > images?.length - 1) return 0;
    if (number < 0) return images?.length - 1;
    return number;
  };

  const nextPerson = () => {
    setIndex((index) => {
      let newIndex = index + 1;
      return checkNumber(newIndex);
    });
  };

  const prevPerson = () => {
    setIndex((index) => {
      let newIndex = index - 1;
      return checkNumber(newIndex);
    });
  };

  return (
    <div className="gallery-container">
      <div
        className="image-container"
        onMouseEnter={() => setShowZoom(true)}
        onMouseLeave={() => setShowZoom(false)}
        onMouseMove={handleMouseMove}
      >
        <SuperZoomMagnifier
            src={bgimage}
            alt="zoomed-image"
            magnifierSize={180} 
            zoomLevel={12}
            className="main-image"
          />

      </div>
      <div className="navigation-controls">
        <NavigateBefore onClick={prevPerson} className="nav-arrow" style={{ width: "50px", height: "50px" }} />
        <NavigateNext onClick={nextPerson} className="nav-arrow" style={{ width: "50px", height: "50px" }} />
      </div>
    </div>
  );
};

export default PhotoGallery;